import React, { useState } from 'react'
import type { PropsWithChildren } from 'react'
import AbsenceRequestContext from './context'

const AbsenceRequestProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [showAbsencePlannerDrawer, setShowAbsencePlannerDrawer] = useState<boolean>(false)

  return (
    <AbsenceRequestContext.Provider
      value={{
        showAbsencePlannerDrawer,
        setShowAbsencePlannerDrawer,
      }}
    >
      {children}
    </AbsenceRequestContext.Provider>
  )
}

export default AbsenceRequestProvider
